export type PaginatedPayloads =
    | MyBrokerApi.AccessRightPayload
    | MyBrokerApi.ActivityPayload
    | MyBrokerApi.BrokerPayload
    | MyBrokerApi.CategoryContractPayload
    | MyBrokerApi.ClaimModelPayload
    | MyBrokerApi.ClaimV2Payload
    | MyBrokerApi.CommunicationSalaryFormPerPolicyHolderPayload
    | MyBrokerApi.ContractV2Payload
    | MyBrokerApi.ConversationPayload
    | MyBrokerApi.DocumentPayload
    | MyBrokerApi.DocumentToSignPayload
    | MyBrokerApi.DocumentToSignPerPolicyHolderPayload
    | MyBrokerApi.DocumentsPackageToSignPayload
    | MyBrokerApi.DocumenttPayload
    | MyBrokerApi.InsuredGoodCategoryPayload
    | MyBrokerApi.InsuredGoodsPayload
    | MyBrokerApi.InvoicePayload
    | MyBrokerApi.Liability10YearsFormPerPolicyHolderPayload
    | MyBrokerApi.RelatedClaimPayload
    | MyBrokerApi.RelatedContractPayload
    | MyBrokerApi.ToDoPayload
    | MyBrokerApi.UserRequestPayload;

export const defaultPaginationPayload = {
    limit: 0,
    start: 0,
    total: 0,
    result: [],
    message: "",
    links: [],
    pageNumber: 0,
    pageSize: 0,
};
